<template>
  <div
    class="background d-flex align-center justify-center"
    style="overflow: hidden; width: 100%"
  >
    <div style="height: 100%; width: 100%">
      <v-row style="height: 100%; width: 100%">
        <v-col cols="4" style="height: 100%">
          <Tree
            @openFile="openFile"
            style="border-right: solid gray 1px; height: 100%; overflow-y: auto"
          />
        </v-col>
        <v-col cols="8" style="height: 100%">
          <Viewer ref="viewer" style="height: 100%" />
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import Tree from "../components/leodata/Tree.vue";
import Viewer from "../components/leodata/Viewer.vue";

export default {
  components: { Tree, Viewer },
  methods: {
    openFile(fileId) {
      this.$refs.viewer.openFile(fileId);
    },
  },
};
</script>
